import { trpc } from '@/main'
import { createFileRoute } from '@tanstack/react-router'
import { pageSeo } from '@/lib/seo'
import { msg } from '@lingui/core/macro'
import { noop, useSuspenseQuery } from '@tanstack/react-query'

export const Route = createFileRoute('/_landing/cookies-policy')({
  // Locale resolved server-side from the request cookie — see terms-of-use.tsx.
  context: () => ({ legalDocumentQueryOptions: trpc.legal.getDocument.queryOptions({ document: 'cookies-policy' }) }),
  loader: ({ context }) => {
    context.queryClient.query(context.legalDocumentQueryOptions).catch(noop)
  },
  head: (ctx) =>
    pageSeo(ctx, {
      path: '/cookies-policy',
      title: msg`Cookies policy`,
      description: msg`The cookies D’Anchiano uses, what each one is for, and how to manage your preferences at any time.`,
    }),
  component: RouteComponent,
  pendingComponent: () => <div className="mx-auto max-w-4xl p-8" />,
})

function RouteComponent() {
  const { data } = useSuspenseQuery(Route.useRouteContext().legalDocumentQueryOptions)

  return (
    <article
      className="unreset-tailwind mx-auto max-w-4xl p-8 break-words"
      // Trusted first-party content: build-time, repo-authored markdown (server legal/content/*/*.md)
      // bundled via Vite `?raw` + rendered with `Bun.markdown` — there is no user-controlled input path.
      // react-doctor-disable-next-line react-doctor/dangerous-html-sink -- trusted build-time legal HTML
      dangerouslySetInnerHTML={{ __html: data.html }}
    />
  )
}
